import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function EmptyState({
  children,
  className,
  icon,
}: {
  children: ReactNode;
  className?: string;
  icon?: ReactNode;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200/90 bg-gradient-to-b from-slate-50/80 to-white/60 px-6 py-16 text-center shadow-inner shadow-slate-900/[0.02]',
        className
      )}
    >
      {icon ? <div className="mb-4 text-teal-600/70">{icon}</div> : null}
      <p className="max-w-md text-sm leading-relaxed text-slate-600">{children}</p>
    </div>
  );
}
